import { TableModel } from "./model";
import styled from "styled-components";

const Table = styled(TableModel)`
  #root && {
    overflow-y: hidden;
  }
`;
export { Table };
